module.exports = __webpack_public_path__ + "media/images/grow_and_eat-b36b43b8399d034a628d0665925b822f.jpg";